'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Recommendations = require('./components/Recommendations.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Recommendations).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/recommendations/lib/index.js
// module id = 1461
// module chunks = 1